import { TobaccoUse } from '@hc-frontend/core-types';

export function tobaccoTextToTobaccoUse(
  tobacco: 'y' | 'n' | undefined,
): TobaccoUse | undefined {
  if (tobacco === undefined) return undefined;

  return tobacco === 'y' ? TobaccoUse.Enum.YES : TobaccoUse.Enum.NO;
}
